"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
require("./Switch.css");
var _cdsCommon = require("@cbhq/cds-common");
var _useSpectrumConditional = require("@cbhq/cds-common/hooks/useSpectrumConditional");
var _switch = require("@cbhq/cds-common/motion/switch");
var _tokens = require("@cbhq/cds-common/motion/tokens");
var _Box = require("../layout/Box");
var _utils = require("../motion/utils");
var _borderRadius = require("../styles/borderRadius");
var _ThemeProvider = require("../system/ThemeProvider");
var _tokens2 = require("../tokens");
var _linaria = require("../utils/linaria");
var _Control = require("./Control");
var _useControlMotionProps = require("./useControlMotionProps");
const _excluded = ["children", "checked"];
/* eslint-disable @typescript-eslint/no-use-before-define */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const MotionBox = (0, _framerMotion.m)(_Box.Box);
const thumbMotionVariants = {
  checked: {
    x: `calc(${_tokens2.control.switchWidth} - ${_tokens2.control.switchThumbSize} - 2px)`
  },
  unchecked: {
    x: 0
  }
};
const SwitchWithRef = /*#__PURE__*/(0, _react.forwardRef)(function SwitchWithRef(_ref, ref) {
  let children = _ref.children,
    checked = _ref.checked,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  // Switch thumb is a special case where it should always be white.
  const thumbColor = (0, _useSpectrumConditional.useSpectrumConditional)({
    light: primaryForegroundThumb,
    dark: foregroundThumb
  });
  const _useControlMotionProp = (0, _useControlMotionProps.useControlMotionProps)({
      checked,
      initialBackground: _tokens2.palette.backgroundAlternate
    }),
    outerContainerMotionProps = _useControlMotionProp.outerContainerMotionProps;
  const switchNode = /*#__PURE__*/_react.default.createElement(_Control.Control, _extends({
    ref: ref,
    background: checked ? 'primary' : 'backgroundAlternate',
    borderRadius: "roundedLarge",
    checked: checked,
    label: children,
    role: "switch",
    type: "checkbox"
  }, props), /*#__PURE__*/_react.default.createElement(_framerMotion.m.div, _extends({
    className: (0, _linaria.cx)(track, focusRing),
    "data-filled": checked
  }, outerContainerMotionProps), /*#__PURE__*/_react.default.createElement(MotionBox, {
    animate: checked ? 'checked' : 'unchecked',
    className: (0, _linaria.cx)(thumb, _borderRadius.roundedFull, thumbColor),
    elevation: 1,
    initial: false,
    transition: (0, _utils.convertTransition)(_switch.switchTransitionConfig),
    variants: thumbMotionVariants
  })));
  return /*#__PURE__*/_react.default.createElement(_ThemeProvider.ThemeProvider, {
    palette: _cdsCommon.switchPalette
  }, children ? /*#__PURE__*/_react.default.createElement(_Box.Box, {
    alignItems: "center",
    minHeight: _tokens2.control.switchHeight,
    role: "presentation",
    width: "fit-content"
  }, switchNode) : switchNode);
});
const Switch = /*#__PURE__*/(0, _react.memo)(SwitchWithRef);
exports.Switch = Switch;
const track = "cds-track-t8jm4rz";
const thumb = "cds-thumb-tuy2can";
const primaryForegroundThumb = "cds-primaryForegroundThumb-pgqceed";
const foregroundThumb = "cds-foregroundThumb-fnb1m1h";
const FOCUS_PADDING = 4;
const focusRing = "cds-focusRing-f18ub7wt";